import { getSettings, saveSettings } from './storage';

/* ───────────────────── Credit Costs ───────────────────── */

export const CREDIT_COSTS = {
  vehicleAnalysis: 3,    // Full vehicle analysis with web search (Processing.jsx)
  maintenanceUpdate: 3,  // Targeted maintenance recommendation refresh
  valuationUpdate: 3,    // Targeted market value refresh with web search
  autoAdvisor: 3,        // Auto Advisor market analysis with web search
  autoAdvisorPhoto: 5,   // Auto Advisor with photo/vision analysis (gpt-4o)
  repairQuote: 3,        // Repair quote analysis with web search
  repairQuotePhoto: 5,   // Repair quote with photo extraction (gpt-4o)
  diyGuide: 1,           // DIY guide generation
  challengeStep: 1,      // DIY step verification
  chatMessage: 1,        // Chat message (text-only, gpt-4o-mini)
  chatMessagePhoto: 2,   // Chat message with photo (gpt-4o vision)
};

/* ───────────────────── Credit Operations ───────────────────── */

/**
 * Check if the user has enough credits for an operation.
 */
export function hasCredits(cost = 1) {
  const settings = getSettings();
  const { creditsUsed, creditsTotal } = settings.subscription;
  return (creditsTotal - creditsUsed) >= cost;
}

/**
 * Get remaining credits.
 */
export function getRemainingCredits() {
  const settings = getSettings();
  const { creditsUsed, creditsTotal } = settings.subscription;
  return Math.max(0, creditsTotal - creditsUsed);
}

/**
 * Deduct credits after a successful API call.
 * Returns { success, remaining } — success is false if insufficient credits.
 */
export function deductCredits(cost = 1) {
  const settings = getSettings();
  const { creditsUsed, creditsTotal } = settings.subscription;
  const remaining = creditsTotal - creditsUsed;

  if (remaining < cost) {
    return { success: false, remaining: Math.max(0, remaining) };
  }

  settings.subscription.creditsUsed = creditsUsed + cost;
  saveSettings(settings);

  return { success: true, remaining: remaining - cost };
}

/**
 * Refund credits on API call failure.
 * Returns { remaining }.
 */
export function refundCredits(cost = 1) {
  const settings = getSettings();
  settings.subscription.creditsUsed = Math.max(0, settings.subscription.creditsUsed - cost);
  saveSettings(settings);

  const remaining = settings.subscription.creditsTotal - settings.subscription.creditsUsed;
  return { remaining: Math.max(0, remaining) };
}

/**
 * Sync local credit display from server-side response.
 * Called after every ai-proxy call to keep localStorage in sync
 * with the server's authoritative credit count.
 */
export function syncCreditsFromResponse(creditsRemaining) {
  if (creditsRemaining == null || creditsRemaining < 0) return;
  const settings = getSettings();
  const total = settings.subscription.creditsTotal;
  settings.subscription.creditsUsed = Math.max(0, total - creditsRemaining);
  saveSettings(settings);
}
